var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockwiseSpin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.1726 30.5267C66.1726 28.5899 65.7911 26.6721 65.0499 24.8827C64.3087 23.0934 63.2224 21.4675 61.8529 20.098C60.4833 18.7285 58.8575 17.6422 57.0681 16.901C55.2788 16.1598 53.361 15.7783 51.4242 15.7783C49.4874 15.7783 47.5696 16.1598 45.7802 16.901C43.9909 17.6422 42.365 18.7285 40.9955 20.098C39.626 21.4675 38.5396 23.0934 37.7984 24.8827C37.0573 26.6721 36.6758 28.5899 36.6758 30.5267",
    stroke: "#FFB600",
    strokeWidth: 4.62695
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1758 30.2373L66.1525 61.3189",
    stroke: "#FFB600",
    strokeWidth: 4.62695
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3082 65.5515C73.245 65.5515 75.1629 65.17 76.9522 64.4288C78.7416 63.6876 80.3674 62.6013 81.7369 61.2318C83.1065 59.8623 84.1928 58.2364 84.934 56.447C85.6752 54.6577 86.0566 52.7399 86.0566 50.8031C86.0566 48.8663 85.6752 46.9485 84.934 45.1591C84.1928 43.3698 83.1065 41.7439 81.7369 40.3744C80.3674 39.0049 78.7416 37.9185 76.9522 37.1773C75.1629 36.4362 73.245 36.0547 71.3082 36.0547",
    stroke: "#FFB600",
    strokeWidth: 4.62695
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5977 65.5518L40.5161 65.5285",
    stroke: "#FFB600",
    strokeWidth: 4.62695
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3168 34.8284C28.38 34.8284 26.4621 35.2099 24.6728 35.9511C22.8834 36.6922 21.2576 37.7786 19.8881 39.1481C18.5185 40.5176 17.4322 42.1435 16.691 43.9328C15.9498 45.7222 15.5684 47.64 15.5684 49.5768C15.5684 51.5136 15.9498 53.4314 16.691 55.2208C17.4322 57.0101 18.5185 58.636 19.8881 60.0055C21.2576 61.375 22.8834 62.4614 24.6728 63.2025C26.4621 63.9437 28.38 64.3252 30.3168 64.3252",
    stroke: "#FFB600",
    strokeWidth: 4.62695
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0273 34.8281L61.1089 34.8514",
    stroke: "#FFB600",
    strokeWidth: 4.62695
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0403 70.6852C35.0403 72.622 35.4218 74.5398 36.163 76.3292C36.9042 78.1185 37.9905 79.7444 39.36 81.1139C40.7295 82.4834 42.3554 83.5698 44.1447 84.3109C45.9341 85.0521 47.8519 85.4336 49.7887 85.4336C51.7255 85.4336 53.6433 85.0521 55.4327 84.3109C57.222 83.5698 58.8479 82.4834 60.2174 81.1139C61.5869 79.7444 62.6733 78.1185 63.4145 76.3292C64.1556 74.5398 64.5371 72.622 64.5371 70.6852",
    stroke: "#FFB600",
    strokeWidth: 4.62695
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0391 70.9736L35.0623 39.8921",
    stroke: "#FFB600",
    strokeWidth: 4.62695
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockwiseSpin);
export default __webpack_public_path__ + "static/media/Clockwise Spin.1440cd9f0c0f96002f2e00b13a35e677.svg";
export { ForwardRef as ReactComponent };